import { Loader2 } from "lucide-react";
import { ElementType } from "react";
import { createPortal } from "react-dom";
import ConfirmModal from "../../../../../components/confirmViewModal/ConfirmModal";
import NoteAndDocument from "../../../../../components/noteAndDocument/NoteAndDocument";
import PackagingNameSection from "./components/PackagingNameSection";
import { usePackagingBaseScreen } from "./hooks/usePackagingBaseScreen";
import { PackagingModalData } from "./packagingBase.types";
import { PackagingGate } from "./packagingLevel.types";

interface PackagingBaseScreenProps {
  gate: PackagingGate;
  modalData: PackagingModalData;
  Packaging: ElementType;
  PackagingMethod: ElementType;
}

const PackagingBaseScreen = ({
  gate,
  modalData,
  Packaging,
  PackagingMethod
}: PackagingBaseScreenProps) => {
  const {
    isPageLoading,
    isPageFetching,
    nameSectionProps,
    hasSavedName,
    levelSections,
    machineryProps,
    notesProps,
    deleteModalProps
  } = usePackagingBaseScreen({ gate, modalData });

  if (isPageLoading) {
    return (
      <div
        className="tw-flex tw-items-center tw-justify-center tw-py-12"
        aria-busy="true"
        aria-live="polite"
      >
        <Loader2 className="tw-h-8 tw-w-8 tw-animate-spin tw-text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="tw-relative" aria-busy={isPageFetching}>
      {isPageFetching && (
        <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-10 tw-flex tw-justify-end tw-p-3">
          <Loader2 className="tw-h-5 tw-w-5 tw-animate-spin tw-text-muted-foreground" />
        </div>
      )}
      <div className="tw-space-y-5 tw-pb-6">
        <PackagingNameSection {...nameSectionProps} />

        {hasSavedName && (
          <>
            {levelSections.map(section => (
              <Packaging key={section.key} {...section.props} />
            ))}
            <PackagingMethod {...machineryProps} />
            <NoteAndDocument {...notesProps} />
          </>
        )}
      </div>

      {deleteModalProps.visible &&
        createPortal(
          <ConfirmModal
            viewModal={deleteModalProps.visible}
            closeModal={deleteModalProps.onClose}
            cancel={deleteModalProps.onClose}
            approve={deleteModalProps.onConfirm}
            title={deleteModalProps.title}
            subTitle={deleteModalProps.subtitle}
          />,
          document.body
        )}
    </div>
  );
};

export default PackagingBaseScreen;
